// @ts-nocheck
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';

const IssueTypeComponent = ({ attributeInfo, associationTypes }) => {
  const location = useLocation();
  const issueTypeRelation = useMemo(
    () => attributeInfo?.issue_type_entity_relation,
    [attributeInfo]
  );

  const templateName = useMemo(
    () => attributeInfo?.issue_type_template?.template_name,
    [attributeInfo]
  );

  const isTemplatePresent = useMemo(() => {
    return (associationTypes?.[issueTypeRelation] || []).find(
      ({ entity_name }) => entity_name === templateName
    );
  }, [associationTypes, issueTypeRelation, templateName]);

  const link = `${location.pathname}?tab=${issueTypeRelation}&issueType=${templateName}`;

  return !isEmpty(isTemplatePresent) && issueTypeRelation && templateName ? (
    <Link to={link}>{issueTypeRelation}</Link>
  ) : (
    <>-</>
  );
};

IssueTypeComponent.propTypes = {
  attributeInfo: PropTypes.shape({
    issue_type_entity_relation: PropTypes.string,
    issue_type_template: PropTypes.shape({
      template_name: PropTypes.string,
    }),
  }),
  associationTypes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        entity_name: PropTypes.string,
        entity_type: PropTypes.string,
        template_id: PropTypes.string,
        version_id: PropTypes.string,
      })
    )
  ),
};

export default IssueTypeComponent;
